import { render, staticRenderFns } from "./ReturnedGoodsOfUserList.vue?vue&type=template&id=021cac24&scoped=true"
import script from "./ReturnedGoodsOfUserList.vue?vue&type=script&lang=js"
export * from "./ReturnedGoodsOfUserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cac24",
  null
  
)

export default component.exports